import { PerfectPersonalityOptionsType } from './types';

export const PERFECT_PERSONALITY_OPTIONS: PerfectPersonalityOptionsType = [
  {
    id: 'mysterious',
    title: '👽 Mysterious',
  },
  {
    id: 'funny',
    title: '😜 Funny',
  },
  {
    id: 'passionate',
    title: '🔥 Passionate',
  },
  {
    id: 'dominant',
    title: '😈 Dominant',
  },

  {
    id: 'sweet',
    title: '😊 Sweet',
  },
  {
    id: 'shy',
    title: '🌷 Shy',
  },
];
